module.exports = __webpack_public_path__ + "img/2.e8e3c0df.png";